import { Injectable } from '@angular/core';
import { Invoice } from '../modelo/Invoice';

@Injectable({
    providedIn: 'root'
})
export class FacturasService {

    constructor() { }
    
}
